import { useState, useEffect } from 'react'
import OfflineScreen from './OfflineScreen'

export default function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      // Перезагружаем страницу чтобы получить свежие данные
      window.location.reload()
    }

    const handleOffline = () => {
      setIsOnline(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  // Блокируем приложение при отсутствии сети
  if (!isOnline) {
    return (
      <div className="fixed inset-0 z-50">
        <OfflineScreen />
      </div>
    )
  }

  return null
}
